import React from 'react';
import './LegalMentions.css';
import { FaTimes, FaShieldAlt, FaLock, FaFileContract } from 'react-icons/fa';

const LegalMentions = ({ onClose }) => {
  return (
    <div className="legal-overlay">
      <div className="legal-container">
        <button className="legal-close" onClick={onClose} aria-label="Fermer">
          <FaTimes />
        </button>

        <div className="legal-content">
          <div className="legal-header">
            <div className="legal-icon">
              <FaFileContract />
            </div>
            <h1>Mentions Légales</h1>
            <p>Informations légales et conditions d'utilisation</p>
          </div>

          <div className="legal-sections">
            {/* Section 1: Éditeur du site */}
            <section className="legal-section">
              <div className="section-icon">
                <FaShieldAlt />
              </div>
              <h2>1. Éditeur du Site</h2>
              <div className="section-content">
                <p><strong>Raison sociale :</strong> PlumbThe2nd</p>
                <p><strong>Forme juridique :</strong> SASU (Société par Actions Simplifiée Unipersonnelle)</p>
                <p><strong>SIRET :</strong> XXX XXX XXX XXXXX</p>
                <p><strong>Capital social :</strong> XXXX euros</p>
                <p><strong>Siège social :</strong> [Adresse complète]</p>
                <p><strong>Téléphone :</strong> {process.env.REACT_APP_PHONE || '01 23 45 67 89'}</p>
                <p><strong>Email :</strong> {process.env.REACT_APP_EMAIL || 'contact@plumbthe2nd.fr'}</p>
                <p><strong>Directeur de publication :</strong> [Nom du directeur]</p>
              </div>
            </section>

            {/* Section 2: Hébergement */}
            <section className="legal-section">
              <div className="section-icon">
                <FaLock />
              </div>
              <h2>2. Hébergement du Site</h2>
              <div className="section-content">
                <p><strong>Hébergeur :</strong> [Nom de l'hébergeur]</p>
                <p><strong>Adresse :</strong> [Adresse de l'hébergeur]</p>
                <p><strong>Téléphone :</strong> [Téléphone de l'hébergeur]</p>
              </div>
            </section>

            {/* Section 3: Propriété intellectuelle */}
            <section className="legal-section">
              <h2>3. Propriété Intellectuelle</h2>
              <div className="section-content">
                <p>
                  L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
                  et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
                  les documents téléchargeables et les représentations iconographiques et photographiques.
                </p>
                <p>
                  La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est 
                  formellement interdite sauf autorisation expresse du directeur de la publication.
                </p>
              </div>
            </section>

            {/* Section 4: Protection des données */}
            <section className="legal-section">
              <h2>4. Protection des Données Personnelles</h2>
              <div className="section-content">
                <h3>4.1 Collecte des données</h3>
                <p>
                  Les données personnelles collectées via le formulaire de contact sont uniquement utilisées 
                  pour répondre à vos demandes de devis et d'informations. Ces données ne sont jamais 
                  communiquées à des tiers.
                </p>

                <h3>4.2 Données collectées</h3>
                <ul>
                  <li>Nom et prénom</li>
                  <li>Adresse email</li>
                  <li>Numéro de téléphone</li>
                  <li>Message et demandes spécifiques</li>
                </ul>

                <h3>4.3 Vos droits</h3>
                <p>
                  Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez 
                  d'un droit d'accès, de rectification, de suppression et de portabilité de vos données 
                  personnelles.
                </p>
                <p>
                  Pour exercer ces droits, contactez-nous à : {process.env.REACT_APP_EMAIL || 'contact@plumbthe2nd.fr'}
                </p>

                <h3>4.4 Durée de conservation</h3>
                <p>
                  Vos données sont conservées pendant la durée nécessaire à la gestion de votre demande, 
                  puis archivées conformément aux obligations légales.
                </p>
              </div>
            </section>

            {/* Section 5: Cookies */}
            <section className="legal-section">
              <h2>5. Cookies</h2>
              <div className="section-content">
                <p>
                  Ce site utilise des cookies techniques nécessaires à son bon fonctionnement. Ces cookies 
                  ne collectent aucune donnée personnelle et ne sont pas utilisés à des fins publicitaires.
                </p>
                <p>
                  Vous pouvez désactiver les cookies dans les paramètres de votre navigateur, mais cela 
                  pourrait affecter certaines fonctionnalités du site.
                </p>
              </div>
            </section>

            {/* Section 6: Responsabilité */}
            <section className="legal-section">
              <h2>6. Limitation de Responsabilité</h2>
              <div className="section-content">
                <p>
                  Les informations contenues sur ce site sont aussi précises que possible. Toutefois, 
                  PlumbThe2nd ne pourra être tenu responsable des omissions, des inexactitudes et des 
                  carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires 
                  qui lui fournissent ces informations.
                </p>
                <p>
                  PlumbThe2nd ne pourra être tenu responsable des dommages directs ou indirects causés 
                  au matériel de l'utilisateur lors de l'accès au site.
                </p>
              </div>
            </section>

            {/* Section 7: Liens hypertextes */}
            <section className="legal-section">
              <h2>7. Liens Hypertextes</h2>
              <div className="section-content">
                <p>
                  Ce site peut contenir des liens vers d'autres sites. PlumbThe2nd n'exerce aucun contrôle 
                  sur ces sites et décline toute responsabilité quant à leur contenu.
                </p>
                <p>
                  La création de liens vers ce site est autorisée sous réserve d'en informer préalablement 
                  PlumbThe2nd et de ne pas dénaturer son contenu.
                </p>
              </div>
            </section>

            {/* Section 8: Droit applicable */}
            <section className="legal-section">
              <h2>8. Droit Applicable et Attribution de Juridiction</h2>
              <div className="section-content">
                <p>
                  Tout litige en relation avec l'utilisation du site www.plumbthe2nd.fr est soumis au 
                  droit français. Il est fait attribution exclusive de juridiction aux tribunaux compétents 
                  de Paris.
                </p>
              </div>
            </section>

            {/* Section 9: Assurances */}
            <section className="legal-section">
              <h2>9. Assurances Professionnelles</h2>
              <div className="section-content">
                <p><strong>Garantie Décennale :</strong> [Nom de l'assurance] - Contrat n°[Numéro]</p>
                <p><strong>Responsabilité Civile Professionnelle :</strong> [Nom de l'assurance] - Contrat n°[Numéro]</p>
                <p>
                  Ces assurances couvrent l'ensemble de nos activités de plomberie conformément aux 
                  obligations légales en vigueur.
                </p>
              </div>
            </section>

            {/* Section 10: Conditions Générales de Vente */}
            <section className="legal-section">
              <h2>10. Conditions Générales de Vente</h2>
              <div className="section-content">
                <h3>10.1 Devis</h3>
                <p>
                  Tous nos devis sont gratuits et sans engagement. Ils sont valables 30 jours à compter 
                  de leur émission.
                </p>

                <h3>10.2 Tarifs</h3>
                <p>
                  Nos tarifs sont indiqués en euros TTC. Ils incluent la main-d'œuvre et les déplacements 
                  dans notre zone d'intervention. Le matériel est facturé en sus sauf mention contraire.
                </p>

                <h3>10.3 Paiement</h3>
                <p>
                  Le paiement s'effectue à la fin de l'intervention ou selon les modalités convenues pour 
                  les chantiers importants. Nous acceptons les paiements par chèque, virement bancaire ou 
                  espèces (dans la limite légale).
                </p>

                <h3>10.4 Garanties</h3>
                <p>
                  Tous nos travaux bénéficient de la garantie décennale et de la garantie de parfait 
                  achèvement conformément aux dispositions légales.
                </p>
              </div>
            </section>
          </div>

          <div className="legal-footer">
            <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
            <button className="btn btn-primary" onClick={onClose}>
              J'ai compris
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalMentions;
